import { invoke } from "./invoke.js";
import { createOnAndOffNamespaceListeners, } from "./utils.js";
/**
 * Calculate the system idle state.
 * @param idleThreshold - The amount of time (in seconds) before considered idle.
 * @returns The system's current idle state. Can be active, idle, locked or unknown.
 * @public
 */
export async function getSystemIdleState(idleThreshold) {
    return invoke({
        namespace: "powerMonitor",
        method: "getSystemIdleState",
        args: [idleThreshold],
    });
}
/**
 * Calculate system idle time in seconds.
 * @returns Idle time in seconds.
 * @public
 */
export async function getSystemIdleTime() {
    return invoke({
        namespace: "powerMonitor",
        method: "getSystemIdleTime",
        args: [],
    });
}
/**
 * Get the system's current thermal state. (macOS only)
 * @returns The system's current thermal state. Can be unknown, nominal, fair, serious, or critical.
 * @public
 */
export async function getCurrentThermalState() {
    return invoke({
        namespace: "powerMonitor",
        method: "getCurrentThermalState",
        args: [],
    });
}
/**
 * Check if the system is on battery power.
 * @returns Whether the system is on battery power.
 * @public
 */
export async function isOnBatteryPower() {
    return invoke({
        namespace: "powerMonitor",
        property: "onBatteryPower",
    });
}
// Event handling setup
// Assuming a base version for event support, adjust if known
const listeners = createOnAndOffNamespaceListeners("powerMonitor", "1.0.0");
/**
 * Listen for powerMonitor events.
 * @public
 */
export const on = listeners.on;
/**
 * Remove all listeners for powerMonitor events.
 * @public
 */
export const removeAllListeners = listeners.removeAllListeners;
